<template>
  <div class="copy-icas" :class="{'bottom-fixed-icas':isBottmFixed, isOS,'sf-theme': isSfTheme || noBg}">
    <SFBuyCopyRight v-if="isFromSFBuy" />
    <div>
      <span v-if="isSg">Copyright&nbsp;&copy;&nbsp;2023&nbsp;{{ $t('standard.sgSfExpress') }}</span>
      <span v-else-if="!isOS">Copyright&nbsp;&copy;&nbsp;2023&nbsp;{{ $t('standard.sfExpress') }}</span>
      <span v-else-if="isTh">Copyright&nbsp;&copy;&nbsp;2024&nbsp;{{ $t('standard.kex') }}</span>
      <span v-else-if="language === 'id-ID'">{{ $t('standard.sfExpress') }}</span>
      <span v-else-if="isSfTheme">Copyright&nbsp;&copy;&nbsp;2024&nbsp;{{ $t('__origin__.standard.sfExpress') }}</span>
      <span v-else="isOS">{{ $t('standard.iuopOsPatent') }}</span>
      
      <div v-show="setting" class="cookie-set">
        <span class="mr10" @click="showTerms(cookieKey)">{{ $t('cookies.cookieSet') }}</span>
        <span @click="showTerms(privacyPolicyKey)">{{ $t('login.agreeTips') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

import SFBuyCopyRight from '@/components/SFBuyCopyRight'
import { SF_BUY, isOS, isVn, isTh, ISCO, isId } from '@/utils/constant'
import { mapGetters } from 'vuex'
export default {
  name: 'Copyright',
  components: {
    SFBuyCopyRight,
  },
  props: {
    setting: {
      type: Boolean,
      default: true
    },
    noBg: {

      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      isOS: isOS(),
      isTh: isTh(),
      isSg: window.ENV.indexOf('sg') > -1,
      isId: isId(),
      isVn: isVn(),
      ISCO: ISCO
    }
  },
  computed: {
    ...mapGetters(['system_source', 'uiConfig', 'language']),
    isFromSFBuy() {
      return this.system_source === SF_BUY
    },
    isSfTheme() {
      return !!this.uiConfig.sfTheme
    },
    // 是否给Copyright添加margin-bottom
    isBottmFixed() {
      const bool = this.$route.meta.bottomFixed || false
      return bool
    },
    cookieKey() {
      return this.uiConfig.cookieKey || 1
    },
    privacyPolicyKey() {
      return this.uiConfig.privacyPolicyKey || 4
    },

  },
  methods: {
    ...mapMutations({
      setCookieTerms: 'app/SET_COOKIE_TERMS'
    }),
    showTerms(val) {
      // val为1的时候传cookie政策，为4传隐私政策
      this.setCookieTerms({
        title: val === this.cookieKey ? this.$t('cookies.cookie') : this.$t('register.privacyPolicy'),
        show: true,
        type: val
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";
.copy-icas{
  margin: 24px 0;
  padding-bottom: 24px;
  text-align: center;
  font-size:12px;
  font-weight:400;
  color: $color03;
  position: relative;
  &.isOS{
     color: white;
    text-shadow: 0 0 2px #000, 0 0 5px #000, 0 0 10px rgba(0, 0, 0, 0.8);

  }
  &.sf-theme{
    color: $color03;
    text-shadow: none;
  }
  .cookie-set{
    position: absolute;
    right: 48px;
    top: 0;
    cursor: pointer;
    .mr10{
      margin-right: 10px;
    }
  }
  &.fixed-bottom {
    position: absolute;
    margin-bottom: 0;
    bottom: 0;
    width: 100%;
  }
  /*&.white {*/
    /*color: #fff;*/
  /*}*/
}
.bottom-fixed-icas{
  margin-bottom: 85px;
}
</style>
